<template>
    <!-- 工单管理中的工单详情 -->
    <div class="module">
        <helpinfo :helpData="helpData" />
        <div class="module-container">
            <div class="td-card">
                <div class="td-card-title">{{$t('基本信息')}}</div>
                <div class="td-card-content">
                    <Row>
                        <Col v-for="(item, index) in infoData"
                             style="margin-bottom: 15px;word-break: break-all;"
                             :key="index"
                             span="8"> {{item.name}}：{{item.value}}</Col>
                    </Row>
                </div>
            </div>
            <div class="td-card"
                 v-show="detailData.status!=='01'">
                <div class="td-card-title">{{$t('交流记录')}}</div>
                <div class="td-card-content opacity1">
                    <div v-for="(item, key) in recordList"
                         :key="key"
                         class="content-record">
                        <div class="img-container">
                            <img src="@/assets/images/small-logo.png"
                                 alt="">
                        </div>
                        <div class="content">
                            <div class="dsc">
                                {{item.type != '02' ? $t('售后工程师'): item.username}}：{{item.content}}
                            </div>
                            <div class="time">{{item.time}}</div>
                        </div>
                    </div>
                    <div class="reply-cont"
                         v-show="isDeal">
                        <Input v-model="replyInfo"
                               type="textarea"
                               :autosize="{minRows: 6,maxRows: 15}"
                               :placeholder="$t('最大文本长度为2000个字符')"
                               :maxlength='2000' />
                        <div class="reply-btn">
                            <Button @click="closeTicket"
                                    :disabled="!hasPermission('CD06')"
                                    :loading="loadingClose"
                                    type="default">
                                <span v-show="!loading">{{$t('关闭工单')}}</span>
                                <span v-show="loading">{{$t('关闭中')}}</span>
                            </Button>
                            <Button type="primary"
                                    :disabled="!hasPermission('CD05')"
                                    @click="dailFun"
                                    :loading="loading">
                                <span v-show="!loading">{{$t('处理')}}</span>
                                <span v-show="loading">{{$t('处理中')}}</span>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import helpinfo from '@/views/components/basic/helpinfo'
// import { formatDateTime } from '@/service/utils'
import API from '@/service/api.js'
export default {
    name: 'myticketdetails',
    components: {
        helpinfo
    },
    data () {
        return {
            helpData: {
                modelName: this.$t('工单详情'),
                showBack: true
            },
            infoData: [
                {
                    key: 'ticketNo',
                    name: this.$i18n.t('工单编号'),
                    value: ''
                },
                {
                    key: 'ticketCategoryName',
                    name: this.$i18n.t('类型'),
                    value: ''
                },
                {
                    key: 'status',
                    name: this.$i18n.t('状态'),
                    value: ''
                },
                {
                    key: 'createdBy',
                    name: this.$i18n.t('提交人'),
                    value: ''
                },
                {
                    key: 'createdDt',
                    name: this.$i18n.t('提交时间'),
                    value: ''
                },
                {
                    key: 'ticketContent',
                    name: this.$i18n.t('工单内容'),
                    value: ''
                }
            ],
            replyInfo: '',
            recordList: [],
            loading: false,
            loadingClose: false,
            isDeal: false,
            detailData: {
                status: ''
            }
        }
    },
    created () {
        this.getDetailFun()
    },
    methods: {
        // 获取工单详情
        getDetailFun () {
            this.axios.get(this.urlFormat(API.GET_TICKETMGT_DETAIL, true, [this.$route.params.id, this.$store.state.user.currentUser.info.userSid])).then(res => {
                this.detailData = res
                this.infoData.forEach(item => {
                    item.value = res[item.key]
                    if (item.key === 'status') {
                        switch (res[item.key]) {
                            case '01':
                                item.value = this.$i18n.t('待分配')
                                break
                            case '02':
                                item.value = this.$i18n.t('处理中')
                                break
                            case '03':
                                item.value = this.$i18n.t('已关闭')
                                break
                        }
                    }
                })
                this.recordList = res.recordList
                this.isDeal = res.allocationTicketUser === this.$store.state.user.currentUser.info.account && res.status === '02'
                this.loading = false
            })
        },
        // 关闭工单
        closeTicket () {
            this.$Modal.confirm({
                title: '关闭',
                content: this.$t('确定要关闭该工单?'),
                onOk: () => {
                    this.loadingClose = true
                    this.axios.post(this.urlFormat(API.TICKETMGT_ID_SOLVE, true, [this.$route.params.id]))
                        .then(res => {
                            this.$router.push({ path: '/workorders', query: { type: 'detailok' } })
                        })
                }
            })
        },
        // 处理工单
        dailFun () {
            this.loading = true
            if (!this.replyInfo.trim()) {
                this.$Message.error(this.$t('请输入聊天内容'))
                this.loading = false
                return
            }
            const submitObj = {
                username: this.$store.state.user.currentUser.info.account,
                type: this.recordList[0].type,
                content: this.replyInfo
                // time: formatDateTime(new Date())
            }
            this.detailData.recordList.push(submitObj)
            this.detailData.communicateRecord = JSON.stringify(this.detailData.recordList)
            this.axios.post(this.urlFormat(API.POST_TICKETFEEDBACK, false), this.detailData).then(res => {
                this.getDetailFun()
                this.replyInfo = ''
            })
        }
    }
}
</script>
<style lang="less" scoped>
.module {
    .td-card {
        .td-card-title {
            padding-bottom: 15px;
            border-bottom: 1px solid #e9e9e9;
            font-size: 14px;
            font-weight: 500;
            color: #333333;
        }
        .td-card-content {
            padding: 18px 20px 0px;
            font-size: 12px;
            opacity: 0.8;
            color: #333333;
            .content-record {
                width: 100%;
                padding: 10px 0px;
                border-bottom: 1px solid #e9e9e9;
                display: flex;
                .img-container {
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    background-color: #418bcc;
                    text-align: center;
                    img {
                        width: 37px;
                        height: 37px;
                        margin-top: 50%;
                        transform: translateY(-50%);
                    }
                }
                .content {
                    margin-left: 15px;
                    font-size: 14px;
                    color: #333;
                    .dsc {
                        margin-top: 15px;
                    }
                    .time {
                        margin-top: 10px;
                    }
                }
            }
            .reply-cont {
                margin-top: 15px;
                .reply-btn {
                    margin-top: 15px;
                    float: right;
                }
            }
        }
        .opacity1 {
            opacity: 1;
        }
    }
}
</style>
